import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { InfoIcon } from '../info-icon';

const CustomCell = ({ field, row }) => {
	if (field === 'id') {
		return (
			<div className="custom-cell__id">
				<InfoIcon popupContent={`№ ${row[field]}`} link={row.link} />
			</div>
		);
	}

	if (field === 'contact') {
		return (
			<div className="custom-cell__contact">
				{row.contact.last_name} {row.contact.first_name}
			</div>
		);
	}

	if (field === 'phone') {
		return (
			<a className="custom-cell__link" href={`tel:${row.phone}`}>
				{row.phone}
			</a>
		);
	}

	if (field === 'name') {
		return (
			<Link className="custom-cell__link" to={row.link}>
				{row[field]}
			</Link>
		);
	}

	if (field === 'link' && row[field]) {
		return (
			<a
				className="custom-cell__link"
				target={row[field].target ? row[field].target : '_self'}
				href={row[field].url}
			>
				{row[field].text}
			</a>
		);
	}

	if (field === 'contract_date') {
		return row[field] ? new Date(row[field]).toLocaleDateString('ru-RU') : '';
	}

	return row[field];
};

CustomCell.propTypes = {
	row: PropTypes.object.isRequired,
	field: PropTypes.string.isRequired,
};

export { CustomCell };
